var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { isSafari } from '../../mixin/safari-mod';
import { TableDisplay, TableSafari } from './TableDisplay';
import { TableBtnCol, TableData, TableHeader, TableRow } from './TableRowContent';
import { SortableHeader } from './features/SortableHeader';
import { StickyRowHeader } from './features/StickyHeader';
import { TableScroll } from './features/TableScrollable';
import { EmptyRow } from './EmptyRow';
import { FixedTableScrollContainer, FixedTableWrapper, TableScrollBox, } from './features/temporary-features/TableFixedBox';
import { FixedTableContainer } from './features/temporary-features/TableFixedContainer';
export var Table = function (_a) {
    var children = _a.children, size = _a.size, hover = _a.hover, props = __rest(_a, ["children", "size", "hover"]);
    if (isSafari) {
        return (React.createElement(TableScrollBox, { hover: hover },
            React.createElement(TableSafari, __assign({ size: size }, props), children)));
    }
    else {
        return (React.createElement(TableScrollBox, { hover: hover },
            React.createElement(TableDisplay, __assign({ size: size }, props), children)));
    }
};
export var TableStickyScroll = function (_a) {
    var children = _a.children;
    if (isSafari) {
        return (React.createElement(TableScroll, null,
            React.createElement(TableSafari, null, children)));
    }
    else {
        return (React.createElement(TableScroll, null,
            React.createElement(TableDisplay, null, children)));
    }
};
Table.Display = TableDisplay;
Table.Safari = TableSafari;
Table.StickyScroll = TableStickyScroll;
Table.Row = TableRow;
Table.Header = TableHeader;
Table.Data = TableData;
Table.BtnCol = TableBtnCol;
Table.HeaderSortable = SortableHeader;
Table.StickyThead = StickyRowHeader;
Table.Wrapper = FixedTableWrapper;
Table.ScrollContainer = FixedTableScrollContainer;
Table.Fixed = FixedTableContainer;
Table.EmptyRow = EmptyRow;
